$(function(){
    $('.tabs').each(function(){
        let tabs = $(this),
            tabNavBtn = tabs.find('.tab-nav button');

        tabNavBtn.on('click', function(){
            let thisBtn = $(this),
                controls = thisBtn.attr('aria-controls');

            if (thisBtn.attr('aria-selected') === 'true') {
                return;
            }

            switchPanel(controls);
        })
    });
})

export function switchPanel(id) {
    let nextTab = $('#' + id);

    if (nextTab.hasClass('active')) {
        return;
    }

    let nextBtn = $('.tab-nav button[aria-controls="'+id+'"]'),
        tabBtns = nextBtn.closest('.tabs').find('.tab-nav').first().find('button'),
        tabPanels = nextTab.closest('.tab-panels'),
        currentTab = tabPanels.find('> .tab-panel.active'),
        nextTabHeight = nextTab.getScrollHeight();

    tabBtns.attr('aria-selected', false);
    nextBtn.attr('aria-selected', true);

    tabPanels.height(tabPanels.height());

    tabPanels.animate({
        'height': nextTabHeight + 'px'
    }, 400, function(){
        tabPanels.css('height', '');
    });

    currentTab.removeClass('active').fadeOut(200, function(){
        nextTab.addClass('active').fadeIn(200);
    })
}

$.fn.getScrollHeight = function(){
    let hiddenElement = $(this);
    hiddenElement.show();
    let height = hiddenElement[0].scrollHeight;
    hiddenElement.hide();
    return height;
};